import React, {useLayoutEffect, useRef, useState} from "react";
import {Joyride, STATUS} from "react-joyride";

const options = {
            zIndex: 3000,
            primaryColor: "#7467D9",
            textColor: "#25232A",
            backgroundColor: "#FFFFFF",
            overlayColor: "rgba(81, 70, 130, 0.16)",
            spotlightPadding: 10,
            spotlightRadius: 16,
            width: 380,
            overlayClickAction: "none",
            buttons: ["skip", "primary"],
            showProgress: false,
            offset: 18,
            scrollOffset: 80,
            scrollDuration: 400,
            targetWaitTimeout: 0,
        };
const styles = {
            tooltip: {
                background: "linear-gradient(145deg, #ffffff 0%, #fcfbff 100%)",
                border: "none",
                borderRadius: 24,
                boxShadow: "0 24px 60px rgba(55, 42, 96, 0.16), 0 8px 20px rgba(55, 42, 96, 0.08)",
                padding: 28,
            },
            tooltipContainer: {textAlign: "left", lineHeight: 1.55},
            tooltipTitle: {color: "#2f2850", fontSize: 20, fontWeight: 750, letterSpacing: "-0.02em", margin: 0},
            tooltipContent: {color: "#625d72", fontSize: 14, padding: "8px 0 22px"},
            tooltipFooter: {gap: 8},
            buttonPrimary: {
                background: "linear-gradient(135deg, #7467D9 0%, #9B7CF6 100%)",
                borderRadius: 999,
                border: 0,
                boxShadow: "0 7px 16px rgba(116, 103, 217, 0.24)",
                fontSize: 13,
                fontWeight: 700,
                outline: 0,
                padding: "12px 20px",
            },
            buttonSkip: {
                background: "rgba(116, 103, 217, 0.08)",
                borderRadius: 999,
                border: 0,
                boxShadow: "0 4px 10px rgba(116, 103, 217, 0.08)",
                color: "#7467D9",
                fontSize: 13,
                fontWeight: 600,
                outline: 0,
                padding: "12px 16px",
            },
            buttonClose: {border: 0, color: "#8f89a1", outline: 0},
        };
const locale = {skip: "Skip journey", next: "Next", last: "Finish"};
const floatingOptions = {hideArrow: true};

const hasVisibleTarget = (target) => {
    let element;
    try {
        element = typeof target === "string" ? document.querySelector(target)
            : typeof target === "function" ? target()
                : target?.current !== undefined ? target.current : target;
    } catch {
        return false;
    }
    if (!element?.isConnected || !element.getClientRects().length) return false;
    for (let node = element; node instanceof Element; node = node.parentElement) {
        const style = window.getComputedStyle(node);
        if (style.display === "none" || style.visibility === "hidden" || style.visibility === "collapse") return false;
    }
    return true;
};

// A single rendering configuration keeps all onboarding journeys consistent.
export const Journey = ({steps, run = false, onFinish}) => {
    const [journeySteps, setJourneySteps] = useState([]);
    const prepared = useRef(false);

    // Check after the page DOM mounts, once per launch. Keep the list stable
    // during navigation so removing an element cannot change the active index.
    useLayoutEffect(() => {
        if (!run) {
            prepared.current = false;
            setJourneySteps([]);
            return;
        }
        if (prepared.current) return;
        prepared.current = true;
        const available = steps.filter((step) => hasVisibleTarget(step.target))
            .map((step) => ({...step, skipBeacon: true}));
        setJourneySteps(available);
        if (!available.length) onFinish?.(STATUS.FINISHED);
    }, [run, steps, onFinish]);

    return (
        <Joyride
            steps={journeySteps}
            run={run && journeySteps.length > 0}
            continuous
            scrollToFirstStep
            options={options}
            styles={styles}
            locale={locale}
            floatingOptions={floatingOptions}
            onEvent={(data) => {
                if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
                    onFinish?.(data.status);
                }
            }}
        />
    );
};

export default Journey;
